module.exports = __webpack_public_path__ + "assets/img/img-placeholder-reel-w1140.03f8a397.jpg";